import React, { useMemo } from "react";
import { Form } from "semantic-ui-react";
import DescriptionField from "../../Fields/DescriptionField";
import HelpField from "../../components/HelpField";
import RawErrors from "../../components/RawErrors";
import { getSemanticProps, MaybeWrap } from "../../util";
import "./_FieldTemplate.less";
import { FieldTemplateProps } from "@rjsf/core";
import { isSupportedWidget } from "../../../../utils/isSupportedWidget";
//@ts-ignore
import { getDefaultRegistry } from "@rjsf/core/lib/utils";
import { FieldError } from "../../components/UnsupportedFieldError";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";

const FieldTemplate: React.FC<FieldTemplateProps> = (rawProps) => {
  const {
    id,
    children,
    displayLabel,
    rawErrors = [],
    rawHelp,
    rawDescription,
    registry = getDefaultRegistry(),
    label,
    ...props
  } = rawProps;
  const { t } = useSchemaTranslation();

  const semanticProps = getSemanticProps(props);
  const { wrapLabel, wrapContent, errorOptions } = semanticProps;

  const widgetName = props.uiSchema["ui:widget"] as string || "";
  const widgetOk = useMemo(() => (id === "root_context" || label === "context") ? true : isSupportedWidget(widgetName, props.schema, registry.widgets), []);

  if (widgetName === "hidden") {
    return null;
  };

  return (
    <Form.Group
      id={`${id}-field-template`}
      className="sui-field-template"
      key={id}
      widths="equal"
      grouped
    >
      <MaybeWrap wrap={wrapContent} className="sui-field-content">
        {widgetOk ? children : <FieldError {...rawProps} />}
        <HelpField helpText={t(rawHelp)} id={id + "__help"} />
        <RawErrors errors={rawErrors} options={errorOptions} id={id} />
        {displayLabel && rawDescription && (
          <MaybeWrap wrap={wrapLabel} className="sui-field-label" >
            {rawDescription && (
              <DescriptionField description={t(rawDescription)} />
            )}
          </MaybeWrap>
        )}
      </MaybeWrap>
    </Form.Group>
  );
};

export default FieldTemplate;
